// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const postApi = baseApi.injectEndpoints({
  reducerPath: "postApi",
  endpoints: (builder) => ({
    deleteComment: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/post-comments/post/${slug}`,
          method: "DELETE",
          // body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deletePost: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/posts/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["deletePost"],
    }),
    getPostDetailsWithComment: builder.query({
      query: (slug) => {
        return {
          url: `admin/post-comments/post/${slug}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getAllPosts: builder.query({
      query: ({ search, limit, page, post_type, group_id }) => {
        return {
          url: `admin/posts?search=${search}&page=${page}&limit=${limit}&post_type=${post_type}&group_id=${group_id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getPostsList: builder.query({
      query: () => ({
        url: "admin/posts?is_paginate=false",
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    postStatus: builder.mutation({
      query: (id) => {
        return {
          url: `admin/posts/status/${id}`,
          method: "PUT",
          // body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useDeleteCommentMutation,
  useDeletePostMutation,
  useGetPostDetailsWithCommentQuery,
  useGetAllPostsQuery,
  useGetPostsListQuery,
  usePostStatusMutation,
} = postApi;
